import { usePage } from "@inertiajs/react";
import { useEffect } from "react";
import { toast } from "sonner";

import { DefaultPageType } from "types/DefaultPageType";

export default function FlashManager() {
  const { flash } = usePage<DefaultPageType>().props;

  useEffect(() => {
    if (flash) {
      if (flash.notice) {
        toast.success(flash.notice);
      }
      if (flash.error) {
        toast.error(flash.error);
      }
    }
  }, [flash?.notice, flash?.error]);

  return <></>;
}
